import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import Observer from "./observer.js";
import { CreateIFrameDocument } from "../../common/messages.js";

var ShadowRootObserver = /*#__PURE__*/function (_Observer) {
  _inherits(ShadowRootObserver, _Observer);

  var _super = _createSuper(ShadowRootObserver);

  function ShadowRootObserver() {
    _classCallCheck(this, ShadowRootObserver);

    return _super.apply(this, arguments);
  }

  _createClass(ShadowRootObserver, [{
    key: "observe",
    value: function observe(el) {
      var _this = this;

      var shRoot = el.shadowRoot;
      var hostID = this.app.nodes.getID(el);

      if (!shRoot || hostID === undefined) {
        return;
      } // log


      this.observeRoot(shRoot, function (rootID) {
        if (rootID === undefined) {
          console.log("OpenReplay: Shadow Root was not bound");
          return;
        }

        _this.app.send(CreateIFrameDocument(hostID, rootID));
      });
    }
  }]);

  return ShadowRootObserver;
}(Observer);

export { ShadowRootObserver as default };